// register.js
let registration = null;

export const registerServiceWorker = async ({ onSuccess, onUpdate } = {}) => {
  if (!('serviceWorker' in navigator)) return null;

  try {
    // Register the service worker
    registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
      updateViaCache: 'none'
    });

    // Success callback
    onSuccess?.();

    // Handle updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      
      newWorker.addEventListener('statechange', () => {
        // When the new service worker is installed and waiting
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // Don't prompt for reload, just notify that new content is available
          onUpdate?.();
          
          // The next time user visits the site or refreshes,
          // they'll get the new version automatically
        }
      });
    });

    // Check for updates periodically
    setInterval(() => {
      registration?.update();
    }, 1000 * 60 * 60); // Every hour

    return registration;
  } catch (error) {
    console.error('Service Worker registration failed:', error);
    return null;
  }
};

// You can keep this function if you need it
export const checkServiceWorkerStatus = async () => {
  if (!('serviceWorker' in navigator)) {
    return { supported: false };
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    return {
      supported: true,
      active: !!navigator.serviceWorker.controller,
      registrations: registrations.length
    };
  } catch (error) {
    return { supported: true, error: error.message };
  }
};

// New helper function to manually trigger update
export const triggerUpdate = async () => {
  if (registration) {
    await registration.update();
  }
};